<!--The content below is only a placeholder and can be replaced.-->
<!-- <mat-toolbar> My App</mat-toolbar> -->

<!-- TOOLBAR -->
<mat-toolbar class="mat-toolbar mat-elevation-z1"> 
    <mat-toolbar-row >
      <img width="50px" src="./../assets/imagenes/ic_amicare.png">
      <span>Amicare</span>
      <div class="spacer"></div>
      <button class="signOut" (click)="signOut()">
          <mat-icon>exit_to_app</mat-icon>
      </button>
      <!-- <amplify-sign-out 
        button-text="Exit">
      </amplify-sign-out> -->
    </mat-toolbar-row> 
  </mat-toolbar>
  
  <div class="divListUser" *ngIf="(flagUsuarios)">

  <p>LISTADO DE PACIENTES A CARGO</p>
  <ul class="listaUser">
    <li *ngFor="let array_tab_usuarios of this.array_tab_usuarios;">
      <!-- <div [routerLink]="['/main-user', array_tab_usuarios.nombre]" [routerLinkActive]="['actived']"> -->
      <div (click)="loadMainUser(array_tab_usuarios)">
        <mat-icon class="icon" aria-label="User">account_circle</mat-icon>
        <a >{{array_tab_usuarios.nombre + " " + array_tab_usuarios.apellidos}}</a>
      </div>
    </li>
  </ul>

</div>

<mat-spinner class="spinner" *ngIf="(!flagUsuarios)"></mat-spinner>

   
  <footer class="footer mat-elevation-z4">
      <img class="imagencetem " src="./../assets/imagenes/developed_by_cetem.png"/>
      &copy;
  </footer>
  
